<template>
  <div class="InstructionsBlock">
    <div class="InstructionsBlock__point" v-for="point in ['head', 'swipe', 'caption']">
      <button class="InstructionsBlock__trap"  v-if="point == 'caption' && is_introduction"/>
      <div class="InstructionsBlock__icon">
        <img :src="require('./img/' + point + '.png')" />
      </div>
      <div class="InstructionsBlock__point-text">
        <button
          class="InstructionsBlock__btn"
          :class="{ 'is-active': subtitle }"
          v-if="point == 'caption'"
          :style="{ color: subtitle ? chapter.colors.secondary : '#fff'  }"
          @click="$store.commit('app/SET_SUBTITLE', !subtitle)">
          {{ trans(subtitle ? 'turn_off' : 'turn_on')   }}
        </button>
        <div v-if="!usingTab || point !='swipe'" v-html="trans(point)" /> 
        <div v-if="usingTab && point =='swipe'" v-html="trans('swipe_tab')" /> 
      </div>
      <button class="InstructionsBlock__trap end"  v-if="point == 'caption' && is_introduction"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstructionsBlock',
  translations: {
    fr: {
      turn_on: 'Activez',
      turn_off: 'Désactivez',
      head: 'Branchez vos écouteurs',
      swipe: "Faites défiler pour poursuivre l'histoire",
      swipe_tab: "Appuyez sur la touche ENTRÉE pour poursuivre l'histoire",
      caption: 'les sous-titres',
    },
    en: {
      turn_on: 'Turn on',
      turn_off: 'Turn off',
      head: 'Connect your<br>headphones',
      swipe: 'Scroll to continue<br>the story',
      swipe_tab: 'Press ENTER to continue<br>the story',
      caption: 'Closed Captioning',
    }
  },
  computed: {
    is_introduction() { return this.$store.getters['app/is_introduction'] },
    subtitle() { return this.$store.getters['app/subtitle'] },
    usingTab() {
      if(this.$root.usingMouse) return false
      else return true
    }
  },
  watch:{
    is_introduction(nw, od) {
      if(nw == true)
        this.$nextTick(()=>{
          document.querySelector('.InstructionsBlock__trap').focus()
          const trap_end = document.querySelector('.InstructionsBlock__trap.end')
                trap_end.addEventListener('focus', (event) => {
                  document.querySelector('.CTANext__trap').focus()
                }) 
        }) 
    },
  },
  created() {
    this.chapter = _.find(this.chapters, chapter => chapter[this.lang].slug == this.$route.params.chapter )
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.InstructionsBlock

  width 50%
  min-width 380px

  +below(tablet)
    width initial
    min-width auto

  &__point
    display flex
    align-items center
    &:nth-child(2)
      .InstructionsBlock__icon
        position relative

  &__icon
    width 70px
    padding 30px
    flex-basis 70px
    flex-grow 0
    flex-shrink 0

    +below(phone)
      padding 20px

  &__point-text
    font-size 16px
    margin-left 20px
    max-width 250px
    +below(phone)
      font-size 14px
      margin-left 0px
      width 140px

  &__btn
    text-align center
    text-transform uppercase
    margin-bottom 10px
    font-size 12px
    font-weight 900
    letter-spacing .2em
    border 1px solid white
    padding 10px 10px 8px
    cursor pointer
    &.is-active
        background white

  &__trap 
    position absolute
    top 0
    left 0
    width 0px 
    height 0px 
    opacity 0


</style>
